import leaflet, { DomUtil, LeafletEvent } from 'leaflet';
import { MOUSE_BUTTONS } from '../../annotations.interface';
import { DraggableEx } from './DraggableEx';

export class DragEx extends leaflet.Map.Drag {
  addHooks(): void {
    if (this._draggable) {
      this._draggable.disable();
      this._draggable = null;
    }

    const map = this._map;
    this._draggable = new DraggableEx(map.options.draggingButtons, map._mapPane, map._container);
    this._draggable.on(
      {
        dragstart: (e: LeafletEvent) => {
          this._onDragStart(e);
        },
        drag: (e: LeafletEvent) => {
          this._onDrag(e);
        },
        dragend: (e: LeafletEvent) => {
          this._onDragEnd(e);
        },
      },
      this
    );
    this._draggable.on(
      'predrag',
      () => {
        this._onPreDragLimit();
      },
      this
    );

    if (map.options.worldCopyJump) {
      this._draggable.on(
        'predrag',
        () => {
          this._onPreDragWrap();
        },
        this
      );
      map.on(
        'zoomend',
        () => {
          this._onZoomEnd();
        },
        this
      );
      map.whenReady(() => {
        this._onZoomEnd();
      }, this);
    }

    if (map.options.draggingButtons & MOUSE_BUTTONS.LEFT) {
      DomUtil.addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
    }

    this._draggable.enable();
    this._positions = [];
    this._times = [];
  }
}
